/**
 * Un toucher sur un lien du web (un élément du DS qui porte un `href`) : est-il pour l'app, ou pour
 * le navigateur ?
 *
 * La règle de React Navigation (`PlatformPressable`), reprise pour que nos onglets restent ce
 * qu'étaient ceux de la barre legacy : un vrai lien. Un clic simple, gauche, sans touche de
 * modification, est pour l'app — elle navigue, et le défaut du lien (recharger la page) est
 * empêché. Ctrl ou Cmd-clic, Maj-clic, Alt-clic, ou un autre bouton que le gauche : le navigateur
 * ouvre son nouvel onglet ou sa nouvelle fenêtre, et l'app ne fait rien. Le clic du milieu et le
 * menu du clic droit (« Copier le lien ») ne passent même pas par ici.
 */
type LinkPressEvent = {
    metaKey?: boolean
    altKey?: boolean
    ctrlKey?: boolean
    shiftKey?: boolean
    button?: number | null
    preventDefault?: () => void
}

export function isAppLinkPress(event: LinkPressEvent | null | undefined): boolean {
    if (event == null) return true
    const modified = !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
    const leftClick = event.button == null || event.button === 0
    return !modified && leftClick
}

/**
 * Le geste d'un lien : l'app navigue (`onPress`) et empêche le défaut seulement quand le clic est le
 * sien. Sans `href` (le natif, ou un élément qui n'est pas un lien), `onPress` tout court.
 */
export function pressLink(event: unknown, href: string | undefined, onPress: () => void): void {
    if (href == null) {
        onPress()
        return
    }
    const linkEvent = event as LinkPressEvent | null | undefined
    if (!isAppLinkPress(linkEvent)) return
    linkEvent?.preventDefault?.()
    onPress()
}
